export class User {
    constructor(public _id: string,
        public  userName: string, 
        public email: string ,
        private _token: string){}
 get token(){
     if(!this._token){
         return null
     }
     return this._token
 }
}